export enum Permission {
  VIEW_DOWNLOAD_MANDATORY_SW_PACKAGES = 1,
  VIEW_DOWNLOAD_ENTITLEMENT_SW_PACKAGES = 2,
  PRODUCT_LINE_ONBOARDING = 3,
  USER_ANALYTICS = 4,
  CUSTOMER_ONBOARDING = 5,
  PERMISSION_CONFIGURATION = 6,
  INJECTOR_AUTHENTICATION = 7,
  ACTIVATE_DEACTIVATE_SOFTWARE_PACKAGES = 8,
  EDIT_UPDATE_DEACTIVATE_CYBER_USER = 9,
  ONBOARD_ACTIVATE_DEACTIVATE_USERS_EDIT = 10,
  OTHER_EXTERNAL_USER_ONBOARDING_WITHIN_SAME_CUSTOMER_SITE = 11,
  SOFTWARE_PACKAGE_DISTRIBUTION = 12,
  SETUP_MANAGE_TAC_ADMIN_USERS_GLOBAL_SERVICE_TEAM = 13
}

export const Permissions: Record<Permission, string> = {
  [Permission.VIEW_DOWNLOAD_MANDATORY_SW_PACKAGES]: "View and Download Mandatory SW Packages",
  [Permission.VIEW_DOWNLOAD_ENTITLEMENT_SW_PACKAGES]: "View and Download Entitlement SW Packages",
  [Permission.PRODUCT_LINE_ONBOARDING]: "Product Line onboarding",
  [Permission.USER_ANALYTICS]: "User Analytics",
  [Permission.CUSTOMER_ONBOARDING]: "Customer onboarding",
  [Permission.PERMISSION_CONFIGURATION]: "Permission configuration",
  [Permission.INJECTOR_AUTHENTICATION]: "Injector Authentication",
  [Permission.ACTIVATE_DEACTIVATE_SOFTWARE_PACKAGES]: "Activate/Deactivate Software Packages",
  [Permission.EDIT_UPDATE_DEACTIVATE_CYBER_USER]: "Edit/Update/Deactivate Cyber User",
  [Permission.ONBOARD_ACTIVATE_DEACTIVATE_USERS_EDIT]: "Onboard/Activate/De-Activate Users/Edit",
  [Permission.OTHER_EXTERNAL_USER_ONBOARDING_WITHIN_SAME_CUSTOMER_SITE]: "Other External User Onboarding Within Same Customer Site",
  [Permission.SOFTWARE_PACKAGE_DISTRIBUTION]: "Software package distribution",
  [Permission.SETUP_MANAGE_TAC_ADMIN_USERS_GLOBAL_SERVICE_TEAM]: "Setup/manage TAC Admin users / Global service Team",

};
